export default {
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  landing: () => import("/opt/buildhome/repo/layouts/landing.vue").then(m => m.default || m)
}